<app-side-color-card color="primary-1">
  <div class="wrapper" content>
    <h3 class="title">FILTRO DE CONTEÚDO</h3>
    <mat-form-field appearance="outline" class="map-search-input">
      <input matInput [formControl]="control" placeholder="Pesquise por código do item, descrição ou família" 
        aria-label="Filtrar" [matAutocomplete]="auto" [matAutocompletePosition]="'below'"
        (keyup.enter)="applyFilter()"
      />
      <mat-autocomplete #autocomplete #auto="matAutocomplete" [displayWith]="autocompleteDisplayedValue">
        <mat-option *ngFor="let option of filteredOptions | async" [value]="option"
          (onSelectionChange)="onOptionSelected($event)">
          <div *ngIf="option.isFamily">
            Família {{option.product.description}}
          </div>
          <div *ngIf="!option.isFamily">
            {{option.product.sku}} - {{option.product.name}}
          </div>
        </mat-option>
      </mat-autocomplete>
      <button mat-icon-button matSuffix aria-label="Limpar filtro" *ngIf="control.value" 
        (click)="clearFilter()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
  </div>
</app-side-color-card>